import { IApplicationState } from '../../types/redux';

export const getReviewDetailsReviewId = (state: IApplicationState) => {
  return state.reviewsDetails.reviewId;
};
